class DataResult {
    constructor(success, message, data, errorCode) {
        this.success = success;
        this.message = message;
        this.data = data;
        this.errorCode = errorCode;
    }
}

export default DataResult